import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { WorkbookBloc } from '@kp/workbook/workbook.bloc';
import { WINDOW } from '@kservice';
import { Status } from '@ktypes/models';
import { Observable } from 'rxjs';
import { map, skipWhile } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class WorkbookOrderedGuard implements CanActivate {
  constructor(private _workbookBloc: WorkbookBloc, private _router: Router, @Inject(WINDOW) private _window: Window) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    if (!this._workbookBloc.workbookOrderStatus) {
      this._workbookBloc.checkWorkbookOrder();
    }
    return this._workbookBloc.workbookOrderStatus$.pipe(
      skipWhile((workbookOrderStatus) => {
        return ![Status.done, Status.error].includes(workbookOrderStatus.status);
      }),
      map((workbookOrderStatus) => {
        if (workbookOrderStatus.data.requested) {
          const request = this._window.confirm(
            'Your workbook order has already been submitted. If you need to make a change, please contact support@kumanu.com. Press "Cancel" to stay here and continue getting started with Purposeful.'
          );
          return request ? this._router.parseUrl('/welcome') : this._router.parseUrl('/welcome/workbook/confirmed');
        }
        return true;
      })
    );
  }
}
